import React from "react";

const SectionTitle = ({
  title,
  subtitle,
  className = "",
  titleClassName = "",
  subtitleClassName = "",
}) => {
  return (
    <div className={className}>
      <h2 className={`text-2xl font-semibold text-gray-800 ${titleClassName}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-1 text-gray-600 ${subtitleClassName}`}>{subtitle}</p>
      )}
    </div>
  );
};

export default SectionTitle;
